module.exports = __webpack_public_path__ + "images/dialog-box-icon-icon-succeed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dialog-box-icon-icon-succeed.png
// module id = 806
// module chunks = 106